var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 581.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6f9fc;}.cls-2{fill:#e7eff6;}.cls-3{fill:#1263a9;}.cls-4{opacity:0.6;}.cls-5{opacity:0.3;}.cls-14,.cls-15,.cls-18,.cls-19,.cls-20,.cls-23,.cls-5,.cls-6,.cls-8{isolation:isolate;}.cls-15,.cls-6{opacity:0.5;}.cls-7{fill:#263238;}.cls-8{opacity:0.7;}.cls-9{fill:#fafafa;}.cls-10{fill:#e0e0e0;}.cls-11{fill:#f0f0f0;}.cls-12,.cls-18,.cls-23{opacity:0.4;}.cls-13,.cls-15,.cls-18{fill:#fff;}.cls-14{opacity:0.15;}.cls-16{fill:#455a64;}.cls-17{fill:#37474f;}.cls-19{opacity:0.2;}.cls-20{opacity:0.1;}.cls-21{fill:#ffa8a7;}.cls-22{fill:#f28f8f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "login") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-8-2",
    "data-name": "freepik--floor--inject-8",
    className: "cls-1",
    cx: 300,
    cy: 408.71,
    rx: 300,
    ry: 173.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-8-2",
    "data-name": "freepik--shadow--inject-8",
    className: "cls-2",
    d: "M621.3,635.4c-19.7-11.4-19.7-29.8,0-41.1s51.6-11.4,71.2,0,19.7,29.8,0,41.1S641,646.7,621.3,635.4Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-8-3",
    "data-name": "freepik--shadow--inject-8",
    className: "cls-2",
    d: "M221.2,637l-51.7-29.9c-2.9-1.7-2.9-4.4,0-6.1l301-173.8a11.65,11.65,0,0,1,10.6,0l51.8,29.9c2.9,1.7,2.9,4.4,0,6.1L231.8,637A12.3,12.3,0,0,1,221.2,637Z",
    transform: "translate(-149 -166.59)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-8-2",
    "data-name": "freepik--device--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M407.2,583.7,451.7,558c4.6-2.6,6.9-6.1,6.9-9.6v-6.2l-46.1-26a9.51,9.51,0,0,1-4.4-7.6V453.7l-77.7,44.9v54.8a9.77,9.77,0,0,0,4.4,7.6l39.3,22.6C383.2,589,398.1,589,407.2,583.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.2,583.7,451.7,558c4.6-2.6,6.9-6.1,6.9-9.6v-6.2l-46.1-26a9.51,9.51,0,0,1-4.4-7.6V453.7l-77.7,44.9v54.8a9.77,9.77,0,0,0,4.4,7.6l39.3,22.6C383.2,589,398.1,589,407.2,583.7Z",
    transform: "translate(-149 -166.59)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M349,563.1v6.2l-14.2-8.2a9.77,9.77,0,0,1-4.4-7.6V498.6l14.8-8.5c.3,3.8.6,7.6,1,11.5l-10.4,6v42.8a9.62,9.62,0,0,0,4.4,7.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.7,550.3a9.77,9.77,0,0,0,4.4,7.6L374,577.4c9.2,5.3,24,5.3,33.2,0l44.6-25.7c9.2-5.3,9.2-13.9,0-19.2L417.9,513a9.77,9.77,0,0,1-4.4-7.6V462.5l-77.7,44.9Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.7,550.3a9.77,9.77,0,0,0,4.4,7.6L374,577.4c9.2,5.3,24,5.3,33.2,0l44.6-25.7c9.2-5.3,9.2-13.9,0-19.2L417.9,513a9.77,9.77,0,0,1-4.4-7.6V462.5l-77.7,44.9Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M426.8,518.3h0l-9-5.2a9.77,9.77,0,0,1-4.4-7.6V462.6l-77.7,44.9v42.9a9.77,9.77,0,0,0,4.4,7.6l8.9,5.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.6,542.2v6.2c0,3.5-2.3,6.9-6.9,9.6l-44.6,25.7a32.56,32.56,0,0,1-15.9,3.9v-6.2a34,34,0,0,0,15.9-3.9l44.6-25.7C456.3,549.2,458.6,545.7,458.6,542.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M458.6,542.2v6.2c0,3.5-2.3,6.9-6.9,9.6l-44.6,25.7a32.56,32.56,0,0,1-15.9,3.9v-6.2a34,34,0,0,0,15.9-3.9l44.6-25.7C456.3,549.2,458.6,545.7,458.6,542.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.9,603.6a11.86,11.86,0,0,0,10.7-.2L522.1,429.9a12.06,12.06,0,0,0,5.5-9.6V177.2a11.54,11.54,0,0,0-5.2-9.4,11.86,11.86,0,0,0-10.7.2L211.3,341.6a12.05,12.05,0,0,0-5.5,9.6V594.3A11.67,11.67,0,0,0,210.9,603.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.7,603.4,522.2,429.9a12.06,12.06,0,0,0,5.5-9.6V177.2c0-3.5-2.5-5-5.5-3.2L221.7,347.5a12.05,12.05,0,0,0-5.5,9.6V600.2C216.1,603.7,218.6,605.2,221.7,603.4Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.7,603.4,522.2,429.9a12.06,12.06,0,0,0,5.5-9.6V177.2c0-3.5-2.5-5-5.5-3.2L221.7,347.5a12.05,12.05,0,0,0-5.5,9.6V600.2C216.1,603.7,218.6,605.2,221.7,603.4Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.8,609.7a12,12,0,0,1-10-.2,11.7,11.7,0,0,1-5.1-9.4V578l10.4,6v22.1C216.1,609.3,218.2,610.8,220.8,609.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.8,609.7a12,12,0,0,1-10-.2,11.7,11.7,0,0,1-5.1-9.4V578l10.4,6v22.1C216.1,609.3,218.2,610.8,220.8,609.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.1,584v22.1c0,3.5,2.5,5,5.5,3.2L522.1,435.8a12,12,0,0,0,5.5-9.5V404.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.1,583.9v22.2c0,3.5,2.5,5,5.5,3.2L522.1,435.8a12.3,12.3,0,0,0,5.5-9.5V404.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.5,556.2V360.6a7.59,7.59,0,0,1,3.3-5.8L513.9,190.7c1.8-1.1,3.3-.2,3.3,1.9V388.3a7.59,7.59,0,0,1-3.3,5.8l-284.1,164C228,559.2,226.5,558.3,226.5,556.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M226.5,556.2V360.6a7.59,7.59,0,0,1,3.3-5.8L513.9,190.7c1.8-1.1,3.3-.2,3.3,1.9V388.3a7.59,7.59,0,0,1-3.3,5.8l-284.1,164C228,559.2,226.5,558.3,226.5,556.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.9,501.1a11.34,11.34,0,0,0-5.2,9c0,3.3,2.3,4.7,5.2,3a11.34,11.34,0,0,0,5.2-9C377.1,500.7,374.8,499.4,371.9,501.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.7,351.6a10.67,10.67,0,0,0-1.6,5.5V584l-10.3-6V351.2a12.06,12.06,0,0,1,1.6-5.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M527.6,176.3c-.4-2.9-2.7-3.8-5.5-2.3L221.6,347.5a11,11,0,0,0-3.9,4.1l-10.4-6a11,11,0,0,1,3.9-4.1L511.7,168a11.56,11.56,0,0,1,10.7-.2A12.1,12.1,0,0,1,527.6,176.3Z",
    transform: "translate(-149 -166.59)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-8-2",
    "data-name": "freepik--window--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-8-3",
    "data-name": "freepik--window--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-8-4",
    "data-name": "freepik--window--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.8,206.3a2.59,2.59,0,0,0-2.8.2L257.5,370.3a8.36,8.36,0,0,0-3.8,6.7V571.4a3.87,3.87,0,0,0,1.6,3.4c.6.3,4,2.3,5,2.8a2.16,2.16,0,0,0,2.2-.1L546,413.6a8.36,8.36,0,0,0,3.8-6.7V211.5a2.5,2.5,0,0,0-1.2-2.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M262.4,373,546,209.3c2.1-1.3,3.8-.2,3.8,2.2V406.9a8.63,8.63,0,0,1-3.8,6.7L262.4,577.4c-2.1,1.3-3.8-.8-3.8-3.2V379.7A8.63,8.63,0,0,1,262.4,373Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M547.7,210h0c.8,0,.9.9.9,1.5V406.9a7,7,0,0,1-3.2,5.6L261.8,576.3a1.42,1.42,0,0,1-.6.2c-.7,0-1.3-1.1-1.3-2.3V379.7a7,7,0,0,1,3.2-5.6L546.6,210.4a2.1,2.1,0,0,1,1.1-.4m0-1.3a3.37,3.37,0,0,0-1.7.5L262.4,373a8.36,8.36,0,0,0-3.8,6.7V574.2c0,2,1.1,3.6,2.5,3.6a2.2,2.2,0,0,0,1.3-.4L546,413.6a8.36,8.36,0,0,0,3.8-6.7V211.5c0-1.7-.9-2.8-2.1-2.8Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M255.2,574.7c.4.2,3.4,1.9,4.8,2.7a3.77,3.77,0,0,1-1.4-3.3V392.4l-5-2.9V571.4A3.59,3.59,0,0,0,255.2,574.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M549.8,211.5c0-2.4-1.7-3.4-3.8-2.2L262.4,373a8.36,8.36,0,0,0-3.8,6.7v12.7L549.8,224.2V211.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M546,209.3,262.4,373a7.54,7.54,0,0,0-2.7,2.9l-4.9-2.9a8,8,0,0,1,2.7-2.8L541,206.5a2.59,2.59,0,0,1,2.8-.2c.7.4,3.9,2.3,4.7,2.7A2.29,2.29,0,0,0,546,209.3Z",
    transform: "translate(-149 -166.59)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M253.6,389.5V376.9a8.9,8.9,0,0,1,1.2-3.9l4.9,2.9a8.9,8.9,0,0,0-1.2,3.8v12.7Z",
    transform: "translate(-149 -166.59)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M490,358.1l-169.8,98a6.13,6.13,0,0,0-2.8,4.9v48.7a6.4,6.4,0,0,0,2.8,4.9l5,2.9a6.35,6.35,0,0,0,5.7,0l169.8-98a6.13,6.13,0,0,0,2.8-4.9V365.9a6.4,6.4,0,0,0-2.8-4.9l-5-2.9A6.35,6.35,0,0,0,490,358.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M503.5,365.4c-.2-1.5-1.4-2-2.8-1.2l-169.8,98a5.78,5.78,0,0,0-2,2.1l-10.6-6.1a5.78,5.78,0,0,1,2-2.1l169.8-98a6.35,6.35,0,0,1,5.7,0l5,2.9A6.35,6.35,0,0,1,503.5,365.4Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.4,517.7a6.29,6.29,0,0,1-5.2-.2l-5-2.9a6.13,6.13,0,0,1-2.8-4.9V461a5.38,5.38,0,0,1,.8-2.8l10.6,6.1a5.38,5.38,0,0,0-.8,2.8v48.7C328,517.5,329,518.2,330.4,517.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.9,462.2l169.8-98c1.6-.9,2.8-.2,2.8,1.6v48.7a6.4,6.4,0,0,1-2.8,4.9l-169.8,98c-1.6.9-2.8.2-2.8-1.6V467.1A6.28,6.28,0,0,1,330.9,462.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M445,384.1,320.2,456.2a5.78,5.78,0,0,0-2,2.1l10.6,6.1a5.78,5.78,0,0,1,2-2.1l124.8-72Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M455.6,390.2l-124.8,72a6.13,6.13,0,0,0-2.8,4.9v48.7c0,1.8,1.3,2.5,2.8,1.6l124.8-72V390.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.6,456.3,424,419.1c2.7-1.5,4.8-.4,4.8,2.4a10.08,10.08,0,0,1-4.8,8l-64.4,37.2c-2.7,1.5-4.8.4-4.8-2.4A10.23,10.23,0,0,1,359.6,456.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M372.8,468.6c0-.1.1-.1.2,0h0a.37.37,0,0,1,.1.3v7.2a14.92,14.92,0,0,1-.2,2.1,12.09,12.09,0,0,1-.5,1.8,6,6,0,0,1-.9,1.5,6.89,6.89,0,0,1-1.3,1.1,2.84,2.84,0,0,1-1.3.4,1.19,1.19,0,0,1-.9-.5,2.11,2.11,0,0,1-.5-1.3,11.08,11.08,0,0,1-.2-1.9V472a.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3l.8-.5c.1-.1.1-.1.2,0a.37.37,0,0,1,.1.3v7.2a4.87,4.87,0,0,0,.1,1.2,1.08,1.08,0,0,0,.3.7.76.76,0,0,0,.5.2,1.42,1.42,0,0,0,.6-.2,2.65,2.65,0,0,0,.6-.5,2.18,2.18,0,0,0,.5-.8,3.81,3.81,0,0,0,.3-1,5.28,5.28,0,0,0,.1-1.3v-7.2a.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M377.8,475.5a.37.37,0,0,0-.1-.3.31.31,0,0,0-.2-.1H377l-.7.1a.85.85,0,0,1-.7,0c-.2-.1-.3-.2-.5-.3a1.45,1.45,0,0,1-.2-.7,7.39,7.39,0,0,1,0-2.1,3.58,3.58,0,0,1,.4-1.1,8.79,8.79,0,0,1,.6-1,2.36,2.36,0,0,1,.9-.8,1.61,1.61,0,0,1,.9-.3c.2,0,.5,0,.6.1a1,1,0,0,1,.4.5,1.88,1.88,0,0,1,.2.8.6.6,0,0,1-.1.4c0,.1-.1.2-.2.3l-.8.4h-.2l-.2-.1c-.1-.1-.1-.1-.2-.1s-.3.1-.5.2a1.2,1.2,0,0,0-.5.5.84.84,0,0,0-.2.7v.3c0,.1.1.1.2.1h.4l.7-.1a1.37,1.37,0,0,1,1.3.3,2.93,2.93,0,0,1,.4,1.6,5.11,5.11,0,0,1-1.3,3.2,6.47,6.47,0,0,1-.9.8,1.61,1.61,0,0,1-.9.3,1.85,1.85,0,0,1-.7-.2,1,1,0,0,1-.4-.5,1.88,1.88,0,0,1-.2-.8.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3l.8-.4c.1,0,.2-.1.2,0l.2.2a.37.37,0,0,0,.3.1.76.76,0,0,0,.5-.2,2.65,2.65,0,0,0,.6-.5c.1-.1.2-.2.2-.3S377.8,475.6,377.8,475.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M380.4,472a13.55,13.55,0,0,1,.2-2,12.09,12.09,0,0,1,.5-1.8,5.48,5.48,0,0,1,.8-1.5,4.74,4.74,0,0,1,1-1,1.23,1.23,0,0,1,1-.2,2.18,2.18,0,0,1,.8.5,3.7,3.7,0,0,1,.5,1.1,8.75,8.75,0,0,1,.2,1.6v.8a.6.6,0,0,1-.1.4c0,.1-.1.2-.2.3l-3.3,1.9a2,2,0,0,0,.1.7.54.54,0,0,0,.3.4c.1.1.2.1.4.1a.52.52,0,0,0,.4-.2,1,1,0,0,0,.5-.4,2.18,2.18,0,0,0,.3-.5c.1-.1.1-.2.2-.3l.2-.2.8-.5h.2a.37.37,0,0,1,.1.3,1.85,1.85,0,0,1-.2.7,10.37,10.37,0,0,1-.4,1,3.59,3.59,0,0,1-.7,1,3.92,3.92,0,0,1-1,.8,1.23,1.23,0,0,1-1,.2,2.18,2.18,0,0,1-.8-.5,3,3,0,0,1-.5-1.3A2.42,2.42,0,0,1,380.4,472Zm2.5-4.1a2.18,2.18,0,0,0-.5.4c-.1.2-.3.4-.3.6a1.42,1.42,0,0,0-.2.6c0,.2-.1.4-.1.6l2.2-1.3a.75.75,0,0,0-.1-.5.52.52,0,0,0-.2-.4c-.1-.1-.2-.2-.3-.2s-.4.1-.5.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M389.3,464.4a2.19,2.19,0,0,0-.9,1,4.67,4.67,0,0,0-.3,1.7v4.6a.6.6,0,0,1-.1.4c0,.1-.1.2-.2.3l-.8.4c0,.1-.1.1-.2,0h0a.37.37,0,0,1-.1-.3v-8.2a.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3l.8-.4c.1-.1.1-.1.2,0a.37.37,0,0,1,.1.3v.4a5.3,5.3,0,0,1,.6-1,2.7,2.7,0,0,1,.8-.7l.5-.3h.2a.37.37,0,0,1,.1.3v1.2a.6.6,0,0,1-.1.4c0,.1-.1.2-.2.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.8,463.8c0-.1.1-.1.2,0h0a.37.37,0,0,1,.1.3v1.3a.6.6,0,0,1-.1.4.22.22,0,0,1-.2.2l-4.4,2.5c-.1.1-.1.1-.2,0a.37.37,0,0,1-.1-.3V456.7a.6.6,0,0,1,.1-.4.22.22,0,0,1,.2-.2l.8-.5c.1-.1.1-.1.2,0a.37.37,0,0,1,.1.3v9.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M402.7,454.4a1.69,1.69,0,0,1,1-.3,1.23,1.23,0,0,1,.8.4,4.05,4.05,0,0,1,.5.9,6.75,6.75,0,0,1,.2,1.4v1.8a7.77,7.77,0,0,1-.2,1.6,8.8,8.8,0,0,1-.5,1.5,5.67,5.67,0,0,1-.8,1.3,2.84,2.84,0,0,1-1,.9,1.69,1.69,0,0,1-1,.3,1.23,1.23,0,0,1-.8-.4,4.05,4.05,0,0,1-.5-.9,6.75,6.75,0,0,1-.2-1.4v-1.8a9.85,9.85,0,0,1,.2-1.7,8.8,8.8,0,0,1,.5-1.5,5.67,5.67,0,0,1,.8-1.3A3.92,3.92,0,0,1,402.7,454.4Zm1.2,3.2a2,2,0,0,0-.1-.8c0-.2-.1-.3-.3-.4s-.2-.1-.4-.1a.76.76,0,0,0-.4.2c-.1.1-.3.2-.4.3s-.3.3-.4.5-.2.5-.3.7-.1.7-.2,1v1.6a1.88,1.88,0,0,0,.2.8c0,.2.1.3.3.4s.2.1.4.1a.76.76,0,0,0,.4-.2c.1-.1.3-.2.4-.3s.3-.3.4-.5.2-.5.3-.7a3.4,3.4,0,0,0,.1-1v-1.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M409.1,461.8a.78.78,0,0,0,.4-.4,2.09,2.09,0,0,0,.4-.6c.1-.3.2-.5.3-.8a3.08,3.08,0,0,0,.1-1v-.6a1.69,1.69,0,0,1-.2.5,2.19,2.19,0,0,1-.3.5c-.1.2-.3.3-.4.5a1.76,1.76,0,0,1-.5.4,1.49,1.49,0,0,1-.9.2,1.79,1.79,0,0,1-.7-.5,2.1,2.1,0,0,1-.4-1.1,7.72,7.72,0,0,1-.2-1.5v-1.2a9.85,9.85,0,0,1,.2-1.7c.1-.5.3-1.1.4-1.6a8.26,8.26,0,0,1,.7-1.3,2.58,2.58,0,0,1,.9-.9,1.69,1.69,0,0,1,.5-.2h.4c.1,0,.2.1.3.2s.2.1.2.2v-.4a.6.6,0,0,1,.1-.4.22.22,0,0,1,.2-.2l.8-.4c.1-.1.1-.1.2,0a.37.37,0,0,1,.1.3v8.3a8.89,8.89,0,0,1-.7,3.6,4.52,4.52,0,0,1-1.9,2.2,1.61,1.61,0,0,1-.9.3,2.35,2.35,0,0,1-.8-.2,2.65,2.65,0,0,1-.5-.6,2.92,2.92,0,0,1-.2-.9.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3l.7-.4c.1-.1.2-.1.2,0h0l.2.2a1.38,1.38,0,0,0,.4.3C408.6,462.1,408.8,461.9,409.1,461.8Zm-1.2-6.2v1a2.3,2.3,0,0,0,.4,1.4.61.61,0,0,0,.8,0,1.59,1.59,0,0,0,.8-1,4.71,4.71,0,0,0,.4-1.7v-1.4a2,2,0,0,0-.4-1.3.61.61,0,0,0-.8,0,2,2,0,0,0-.8,1,7.87,7.87,0,0,0-.4,2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M414.6,444.3h.2a.37.37,0,0,1,.1.3V446a.6.6,0,0,1-.1.4.22.22,0,0,1-.2.2l-.9.5c0,.1-.1.1-.2,0h0a.37.37,0,0,1-.1-.3v-1.4a.6.6,0,0,1,.1-.4.22.22,0,0,1,.2-.2Zm.2,12a.6.6,0,0,1-.1.4c0,.1-.1.2-.2.3l-.8.4a.14.14,0,0,1-.2,0h0a.37.37,0,0,1-.1-.3v-8.2a.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3l.8-.4c.1-.1.1-.1.2,0a.37.37,0,0,1,.1.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M421.5,452.4a.6.6,0,0,1-.1.4.22.22,0,0,1-.2.2l-.8.4h-.2a.37.37,0,0,1-.1-.3v-4.5a3.65,3.65,0,0,0-.3-1.5c-.2-.3-.5-.4-.9-.1a2.1,2.1,0,0,0-.8,1.1,5.82,5.82,0,0,0-.3,1.9v4.5a.6.6,0,0,1-.1.4c0,.1-.1.2-.2.3l-.8.4c0,.1-.1.1-.2,0h0a.37.37,0,0,1-.1-.3V447a.6.6,0,0,1,.1-.4c0-.1.1-.2.2-.3l.8-.4c0-.1.1-.1.2,0h0a.37.37,0,0,1,.1.3v.4a10.91,10.91,0,0,1,.6-1.1,3,3,0,0,1,.8-.8,1.93,1.93,0,0,1,1-.3,1.79,1.79,0,0,1,.7.5,3.58,3.58,0,0,1,.4,1.1,7.57,7.57,0,0,1,.1,1.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M485.7,415.3l-12.4,7.1,1.9-17.3c-1.5-.8-2.4-2.7-2.4-5.5,0-4.9,3-10.6,6.7-12.7s6.7.1,6.7,5.1a17.36,17.36,0,0,1-2.4,8.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "336.8 248.72 325.9 242.51 324.4 255.91 336.8 248.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M479.5,386.9a14.46,14.46,0,0,0-5.7,7.6l10,5.8h0a17.36,17.36,0,0,0,2.4-8.3C486.3,387,483.3,384.8,479.5,386.9Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419.4,329.1c-4.2-2.4-10.1-2.1-16.6,1.6-12.9,7.5-23.4,25.6-23.4,40.5,0,7.5,2.6,12.7,6.9,15.2l8.2,4.8c4.2,2.4,10.1,2.1,16.6-1.6,12.9-7.4,23.4-25.6,23.4-40.5,0-7.4-2.6-12.7-6.9-15.1",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.2,335.6c-12.9,7.5-23.4,25.6-23.4,40.5s10.5,21,23.4,13.5,23.4-25.6,23.4-40.5S424.1,328.1,411.2,335.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.1,368.6v1.7a37.11,37.11,0,0,1-12.9,13.5c-5,2.9-9.6,3.2-12.9,1.4v-3.5a22.89,22.89,0,0,1,10.5-18.2l3.4-2c3-1.7,5.9-2,8.2-.6S424.1,365.1,424.1,368.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M419.4,329.1l8.3,4.8c-4.2-2.5-10.1-2.1-16.6,1.6-8.5,4.9-15.9,14.3-20,24.5l-8.3-4.8c4.1-10.2,11.5-19.6,20-24.5C409.4,327,415.2,326.7,419.4,329.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M394.4,391l-7.9-4.6c-4.3-2.4-6.9-7.6-6.9-15.2l8.3,4.8C387.9,383.3,390.3,388.5,394.4,391Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M382.9,355.3l8.3,4.8a44.11,44.11,0,0,0-3.4,16h0l-8.3-4.8A45.34,45.34,0,0,1,382.9,355.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M408.2,360.7a4.65,4.65,0,0,1-2.3-.6,5.43,5.43,0,0,1-2.4-5.1,14.59,14.59,0,0,1,6.7-11.6h0a5,5,0,0,1,8,4.7,14.59,14.59,0,0,1-6.7,11.6A5.38,5.38,0,0,1,408.2,360.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M420.4,360.9c-2.3-1.3-5.2-1.1-8.2.6l-3.4,2a22.63,22.63,0,0,0-10.5,18.2v3.5c3.3,1.8,7.9,1.5,12.9-1.4a37.91,37.91,0,0,0,12.9-13.5v-1.7C424.1,365.1,422.8,362.3,420.4,360.9Z",
    transform: "translate(-149 -166.59)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-8-2",
    "data-name": "freepik--plants--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M682.2,581.2s1.7-14.9,9.1-26.4,17.6-18.7,27-19.5,17.2,8,7,14-28.2,12.1-36.5,34.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M682.2,581.2s1.7-14.9,9.1-26.4,17.6-18.7,27-19.5,17.2,8,7,14-28.2,12.1-36.5,34.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M685,577.3h-.1a.52.52,0,0,1-.3-.7c10-24.6,29.1-34.9,37.7-36.9.3-.1.5.1.6.4s-.1.5-.4.6h0c-8.5,2-27.2,12.1-37,36.3C685.4,577.3,685.2,577.4,685,577.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M735.6,577.6c-.9,1.9-3,3-4.9,3.7s-4.1,1.6-5.2,3.5c-2.1,3.7,1.4,8.9-.9,12.5a6.38,6.38,0,0,1-4.5,2.6,34.25,34.25,0,0,1-4.4.4,14.91,14.91,0,0,1-2.1-.2,9.78,9.78,0,0,0-6.1.6c-2.9,1.7-3.8,5.4-5.6,8.2a13.77,13.77,0,0,1-9.9,6.2c-1.3.2-3.8.4-5.1-.3-.1,0-.2-.1-.3-.2h0c-.2-.2-.4-.5-.5-.6v-.1c-.5-1.9.3-3.9.4-5.9v-.4c-.1-2.3-.2-4.6-.2-6.9-.1-4.2-.2-8.5-.1-12.7,0-2.8-.3-5.8.9-8.3,1.3-2.9,4.5-2.9,5.7-5.7.5-1.1.7-2.3,1.2-3.4a9.67,9.67,0,0,1,8.4-5.8c5.6-.3,10.6,4.2,16.2,3.8,1.4-.1,2.9-.6,4.3-.8,4.5-.9,9.8.4,12.3,4.3A6.6,6.6,0,0,1,735.6,577.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M685.4,605.2h0a.42.42,0,0,1-.3-.6c7.7-29,38.2-33.1,45.4-32.6.3,0,.5.2.4.5h0c0,.3-.3.4-.5.4-7-.5-36.8,3.6-44.4,31.9C685.9,605.1,685.7,605.3,685.4,605.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M719.3,590.5c-.1,0-.2-.1-.3-.1a25.29,25.29,0,0,0-20.8-5.8.46.46,0,0,1-.5-.4c0-.3.1-.5.4-.5a26.41,26.41,0,0,1,21.6,6.1.48.48,0,0,1,0,.7h0C719.7,590.6,719.5,590.6,719.3,590.5Z",
    transform: "translate(-149 -166.59)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-8-2",
    "data-name": "freepik--character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M637.9,417.7c-5.3,9-10.5,16.9-14.1,20.7-6.9,3.2-23,8.1-29.3,8.9a5.2,5.2,0,0,1-3.2-.7c-2.5-1.6-4.4-1.9-7-2.8-2-.7-2.9-1.7-3.3-1.3a2.32,2.32,0,0,0,.2,3.2,24.28,24.28,0,0,0,3.2,2.4,20.31,20.31,0,0,1-8.5.2c-5.5-1.4-8,1.2-4.3,7.1,1.3,2.1,6.5,5.5,17.1,4.6a83.49,83.49,0,0,0,11.2-1.3c10.1-2.2,21.4-4.3,28.3-6.4a16.67,16.67,0,0,0,6.7-4.7c11.6-13.3,15.5-22.7,20.6-31.3l-.4-14C646.8,402.1,642.4,410.1,637.9,417.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M656.4,402.1a13.22,13.22,0,0,0-12.6,5.4c-5.7,7.2-15.7,24.6-15.7,24.6s3.3,8.7,12.1,10.2l14.2-19.2C654.5,423.1,661.2,409.8,656.4,402.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 528.9,
    y: 431.01,
    width: 9.3,
    height: 16.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "506.1 430.12 496.8 430.42 496.3 413.01 506.1 412.62 506.1 430.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M688.4,454.7c0,9.2-1.3,83.3-1.3,83.3.2,2.6,2.5,7.5,2.1,17.7-.7,13.8-1.6,50.1-1.6,50.1a12,12,0,0,1-10.3.2s-7.5-50.9-9.2-64.6c-1.5-12-5.2-51.5-5.2-51.5l-5,46.8A56.14,56.14,0,0,1,659,552c-.4,6.4-3.4,39.3-3.4,39.3a12.56,12.56,0,0,1-10.7.9s-5.3-49.7-5.4-55.5c-.1-6.6,3.1-82,3.1-82Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M677.9,609.3V608c-.9.4-2.9,8.6-6.6,12.1-2.9,2.8-6.9,6-7.9,9.1s5.5,5,8.3,4.5c3.2-.6,8.7-2.9,10-5.1s2-5.3,3.1-6.9,3.7-3.3,4.3-5.2a12.52,12.52,0,0,0-.5-5.1c-.4-1.7-.9-3.6-1.5-3.4v1a7,7,0,0,1-4.6,1.6C681.2,610.7,677.9,610.4,677.9,609.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M645.7,594.1c-.5,0-.9.7-1.9,1.9a21.42,21.42,0,0,1-5.4,4.1c-3.5,1.8-10.2,4.6-13.3,6-1.9.9-1.8,3.3.2,4.6s6.7,2.3,12.4,1c3.1-.7,7.2-3.7,9.7-3.6s7.3.1,9.2-1.3,1.1-4.3.6-6.7c-.6-2.7-1.3-7-2.2-6.8v1c-1.1,1.8-6.9,2.5-9.3,1.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M662.9,490a34.68,34.68,0,0,1-12.9-7.7s2.5,4.9,9.9,9.4l-1.6,41.8Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M683.3,403.4s7.6,1.8,7.1,15.6l-1.6,22v33c-6.8,7.7-36.9,7.2-47.3-.6,0,0,1.2-39,1.9-54.1.5-10.7,3-16,13.4-17.2l12.9.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M673.5,374.8a13.92,13.92,0,0,1-13.7,14.3h-.1c-7.6,0-12.1-6.6-13.8-14.3-3.1-14.2,6.2-14.3,13.8-14.3A13.94,13.94,0,0,1,673.5,374.8Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M680.6,380.6s-2.1,10.3-3,12a4.52,4.52,0,0,1-2.5,2.2l.2-7.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M677.9,365.8s1.5-.4,3.1,2.1c1.4,2.2,1.7,7-.5,12.7l-4,.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M679.4,367.9l4.9.1a2.27,2.27,0,0,0-2-2.5h-.2A2.56,2.56,0,0,0,679.4,367.9Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M680,366.7l3.6-3.5a2.36,2.36,0,0,0-3.3-.3l-.1.1A2.77,2.77,0,0,0,680,366.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M675.4,381c.8.5,1.9-1.1,2.9-2.2s4.1-2.1,5.7,1.4-1.1,7-3.4,8.1c-4.1,2-5.4-.9-5.4-.9l-.3,16.4c-5.8,8.9-18.9,8.6-14.2-.4v-5a28.83,28.83,0,0,1-5.9.3c-3.2-.5-5.2-3.1-6.2-6.8-1.6-5.8-2.2-10.5-.8-21.9,1.5-12.5,15.4-12.6,22.9-7.6S675.4,381,675.4,381Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M658,368.2c3.3-.3,6.6-1,10-1.3a5.45,5.45,0,0,1,2.2.1c2.5.7,2.2,3.7,2.6,5.8.7,3.6,1.3,9.7,2.6,9.7.4,0,1.9-2.6,2.9-3.6a5.43,5.43,0,0,0,.9-2.7,34.41,34.41,0,0,0,.5-4.5c.1-1.3.2-2.5.2-3.8a20.75,20.75,0,0,0-.3-4.3,6.83,6.83,0,0,0-1.8-3.2l-.3-.3a16.23,16.23,0,0,0-6-4,35.12,35.12,0,0,0-10.1-2.2,87.84,87.84,0,0,1-10.3-1.3.64.64,0,0,0-.6,0,.89.89,0,0,0-.5.8,4.33,4.33,0,0,0,1.7,4.2c-2.3.2-5-1-7.2-1.6a1.08,1.08,0,0,0-1.1,0c-.2.2-.4.4-.4.6a3.67,3.67,0,0,0-.1,1.8,10.74,10.74,0,0,0,2,5.1,12.53,12.53,0,0,0,6.9,4.5A25.76,25.76,0,0,0,658,368.2Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M660.7,398.5s7.2-1.5,9.7-2.9a8.67,8.67,0,0,0,3.5-3.6,11.61,11.61,0,0,1-2,4.2c-1.8,2.4-11.1,4.2-11.1,4.2v-1.9Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M662.4,379.2a1.45,1.45,0,0,0,1.4,1.5,1.57,1.57,0,0,0,1.7-1.4,1.63,1.63,0,0,0-1.4-1.7,1.57,1.57,0,0,0-1.7,1.4Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M664.7,373l3.1,1.8a1.82,1.82,0,0,0-.7-2.5,1.66,1.66,0,0,0-2.3.6A.1.1,0,0,0,664.7,373Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M661.3,389.5l-3.3,1.3a1.79,1.79,0,0,0,2.1,1.2h.1A2,2,0,0,0,661.3,389.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M649.2,374.3l2.8-2.2a1.63,1.63,0,0,0-2.3-.5.1.1,0,0,0-.1.1A1.9,1.9,0,0,0,649.2,374.3Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M650.4,378.8a1.4,1.4,0,1,0,2.8-.2,1.49,1.49,0,0,0-1.4-1.3,1.39,1.39,0,0,0-1.4,1.5Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "509.1 211.01 509 220.01 503.8 218.81 509.1 211.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "387 286.81 394.9 282.21 398.1 278.31 390.1 283.01 387 286.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "387 286.81 394.9 282.21 398.1 278.31 390.1 283.01 387 286.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.7 299.31 416.7 294.71 423.3 288.81 415.3 293.42 408.7 299.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "408.7 299.31 416.7 294.71 423.3 288.81 415.3 293.42 408.7 299.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M625.5,481.8a16.87,16.87,0,0,1,3.3,8.7A16.87,16.87,0,0,1,625.5,481.8Zm18.5.3c-2.7-18.3-12.5-36.3-24.2-43.1-5.6-3.2-10.8-3.4-15-.9l-7.5,4.3-.4.3c-.3.2-.7.4-1,.6a11.51,11.51,0,0,0-1.7,1.4l-.3.2a5.72,5.72,0,0,0-.7.8c-.2.3-.5.6-.8,1-.5.7-1,1.5-1.5,2.2-.2.4-.4.8-.6,1.3l-65.6-37.9-8,4.6V422l.7.4.6.4v1l-1.3.8v3l9.6,20.4,9.5,5.5,3.2-3.8,8.4,5,4.8,8.3,5.3,3.1,6.7-5.9,8.2,4.7,2.8,11.3L589,484a82.86,82.86,0,0,0,2.5,8.5l.3.9c4.6,12,11.8,22.2,20,26.9a17.73,17.73,0,0,0,3.1,1.5c.6.2,1.1.4,1.7.6a8,8,0,0,0,1.5.3,13.45,13.45,0,0,0,4.9,0l.7-.2.9-.3.7-.3a4.88,4.88,0,0,0,.7-.3c.2-.1.5-.2.7-.3l.3-.2c.1,0,.1,0,.2-.1,1.8-1,6.3-3.6,7.5-4.3,6.1-3.5,10-12.4,10-25A51.73,51.73,0,0,0,644,482.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M623.2,497.2c-3.2-1.8-5.7-7.2-5.7-12.1s2.5-7.3,5.7-5.5,5.7,7.2,5.7,12.1S626.3,499.1,623.2,497.2Zm12.9-10.5c-2.7-18.3-12.5-36.3-24.2-43.1-5.4-3.1-10.4-3.4-14.5-1.2l-.4.3c-.3.2-.7.4-1,.6a11.51,11.51,0,0,0-1.7,1.4l-.3.2a5.72,5.72,0,0,0-.7.8c-.2.3-.5.6-.8,1-.5.7-1,1.5-1.5,2.2-.2.4-.4.8-.6,1.3a30.87,30.87,0,0,0-2.5,7.8l-71-41v5.1l.7.4.6.4v1l-1.3.8v3l9.6,20.4,9.5,5.5,3.2-3.8,8.4,5,4.8,8.3,5.3,3.1,6.7-5.9,8.2,4.7,2.8,11.3L589,484a82.86,82.86,0,0,0,2.5,8.5l.3.9c4.6,12,11.8,22.2,20,26.9a17.73,17.73,0,0,0,3.1,1.5c.6.2,1.1.4,1.7.6a8,8,0,0,0,1.5.3,13.45,13.45,0,0,0,4.9,0l.7-.2.9-.3.7-.3a4.88,4.88,0,0,0,.7-.3c.2-.1.5-.2.7-.3l.3-.2c.1,0,.1,0,.2-.1,5.8-3.7,9.5-12.4,9.5-24.7A61.9,61.9,0,0,0,636.1,486.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M628.9,491.7c0,4.9-2.5,7.3-5.7,5.5s-5.7-7.2-5.7-12.1,2.5-7.3,5.7-5.5a9.3,9.3,0,0,1,2.3,2.1,17.21,17.21,0,0,0,3.3,8.7C628.8,490.9,628.9,491.3,628.9,491.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M644.8,491.7c0,12.6-3.9,21.5-10,25-1.3.7-5.7,3.3-7.5,4.3,5.8-3.7,9.5-12.4,9.5-24.7a79.09,79.09,0,0,0-.7-9.7c-2.7-18.3-12.5-36.3-24.2-43.1-5.4-3.1-10.4-3.4-14.5-1.2l7.5-4.3c4.2-2.4,9.4-2.3,15,.9,11.7,6.8,21.5,24.8,24.2,43.1A80.53,80.53,0,0,1,644.8,491.7Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.8,496.3c0,12.3-3.7,21-9.5,24.7,1.8-1,6.3-3.6,7.5-4.3,6.1-3.5,10-12.4,10-25v-1.4l-8,4.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M636.8,496.3c0,12.3-3.7,21-9.5,24.7,1.8-1,6.3-3.6,7.5-4.3,6.1-3.5,10-12.4,10-25v-1.4l-8,4.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "439.1 296.51 439.1 299.12 367.8 257.92 369.1 257.21 369.1 256.12 439.1 296.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "439.1 297.62 439.1 299.12 367.8 257.92 369.1 257.21 369.1 257.12 439.1 297.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M619.1,516.7a15.71,15.71,0,0,1-7.6-2.3c-11.6-6.7-21.1-26.7-21.1-44.5,0-10.4,3.1-18.2,8.6-21.3,3.8-2.2,8.3-1.9,13.1.8,11.6,6.7,21.1,26.7,21.1,44.6,0,10.4-3.1,18.2-8.6,21.3A11.52,11.52,0,0,1,619.1,516.7Zm-14.5-68.3a8.88,8.88,0,0,0-4.8,1.3c-5,2.9-8,10.5-8,20.2,0,17.4,9.2,36.9,20.4,43.4,4.3,2.5,8.4,2.8,11.8.8,5-2.9,8-10.5,8-20.2,0-17.4-9.2-36.9-20.4-43.4a15,15,0,0,0-7-2.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M590.3,450.1a30.87,30.87,0,0,0-2.5,7.8l-71-41,8-4.6Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M682.6,454.1c3.7-7,8-22.9,10.1-30.8,3-11.3-1.9-18.5-7.4-18.8-3.5.5-14.8,41.9-14.8,41.9-1.3,1-18.6,9.8-24.1,12a4.15,4.15,0,0,1-3.1,0c-2.7-1-4.5-.8-7.1-1-2-.2-3.1-.9-3.3-.5a2.3,2.3,0,0,0,1,3,14.62,14.62,0,0,0,3.6,1.6,20.17,20.17,0,0,1-6.9.9c-5.3-.1-7.3,2.2-3.1,7.6,2.5,3.4,6.8,4.5,16.2,1.2,2.7-.9,6.4-2.8,9.8-4,7.1-2.5,8.9-2.9,14.3-4.7C675.5,459.9,681,457.2,682.6,454.1Z",
    transform: "translate(-149 -166.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M683.3,403.4c3.2.4,6.4,1.2,8.3,3.8s3.5,6.4,1.6,16.5a155.74,155.74,0,0,1-5.8,21s-7.6,3.2-15.6-5l5.5-21.4C677.3,418.4,678.2,404.5,683.3,403.4Z",
    transform: "translate(-149 -166.59)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.17ebf5d11a1dc2cdc0ef6b9f132f69ac.svg";
export { ForwardRef as ReactComponent };